import { User } from "../user/types";

export type TabulationReport = {
  id: string;
  created: string;
  proxyEventId: string;
  type: TabulationType;
  voteCutoff: string | null;
  status: TabulationStatus;
  sendingStatus: TabulationSendingStatus;
  failedAt: string | null;
  sentAt: string | null;
  errorMessage: string | null;
  user: User;
  url: string | null;
  emails: string[];
};

export enum TabulationSendingStatus {
  SENDING = "sending",
  SUCCESS = "success",
  FAILED = "failed",
}

export enum TabulationType {
  TEN_DAY = "ten_day",
  ONE_DAY = "one_day",
  DAY_OF = "day_of",
  ADHOC = "adhoc",
}

export const TABULATION_TYPE_LABELS = {
  [TabulationType.TEN_DAY]: "10 Day",
  [TabulationType.ONE_DAY]: "1 Day",
  [TabulationType.DAY_OF]: "Day-of",
  [TabulationType.ADHOC]: "Ad-hoc",
};

export enum TabulationStatus {
  QUEUED = "queued",
  COLLECTING_TABULATION_BROKER_STATS = "collecting_tabulation_broker_stats",
  COLLECTING_TABULATION_BROKER_STATS_ERROR = "collecting_tabulation_broker_stats_error",
  COLLECTING_TABULATION_BROKER_VOTE_RESULTS = "collecting_tabulation_broker_vote_results",
  COLLECTING_TABULATION_BROKER_VOTE_RESULTS_ERROR = "collecting_tabulation_broker_vote_results_error",
  GENERATING_EXCEL = "generating_excel",
  GENERATING_EXCEL_ERROR = "generating_excel_error",
  UPLOADING_FILE = "uploading_file",
  UPLOADING_FILE_ERROR = "uploading_file_error",
  SENDING_ISSUER_TABULATOR_NOTIFICATION = "sending_issuer_tabulator_notification",
  SENDING_ISSUER_TABULATOR_NOTIFICATION_ERROR = "sending_issuer_tabulator_notification_error",
  SENDING_CONTESTING_PARTY_TABULATOR_NOTIFICATION = "sending_contesting_party_tabulator_notification",
  SENDING_CONTESTING_PARTY_TABULATOR_NOTIFICATION_ERROR = "sending_contesting_party_tabulator_notification_error",
  COMPLETE = "complete",
  COMPLETE_NO_CURRENT_VOTES = "complete_no_current_votes",
  DO_NOT_PROCESS = "do_not_process",
}
